export default __webpack_public_path__ + "static/desktop_right-a02efdcef5d175cb3f41581a059abba1.png";